import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ZODIAC_SIGNS, HOROSCOPE_DATA } from '../constants/zodiac';
import '../App.css';

const HoroscopeDetail = () => {
  const { sign } = useParams();
  const [activeTab, setActiveTab] = useState('today');

  const zodiacSign = ZODIAC_SIGNS.find(s => s.name.toLowerCase() === sign.toLowerCase());
  const horoscopeData = HOROSCOPE_DATA[sign.toLowerCase()];

  if (!zodiacSign || !horoscopeData) {
    return (
      <div className="container">
        <div className="loading">
          <p>Horoscope not found. Please check the zodiac sign.</p>
          <Link to="/" className="back-button">Back to Home</Link>
        </div>
      </div>
    );
  }

  const tabs = [
    { id: 'yesterday', label: 'Yesterday' },
    { id: 'today', label: 'Today' },
    { id: 'tomorrow', label: 'Tomorrow' },
    { id: 'yearly', label: '2026' }
  ];

  const getDateForTab = (tabId) => {
    const today = new Date();
    switch (tabId) {
      case 'yesterday':
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        return yesterday.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
      case 'today':
        return today.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
      case 'tomorrow':
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        return tomorrow.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
      case 'yearly':
        return '2026';
      default:
        return today.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    }
  };

  return (
    <div className="container">
      <div className="astrology-bg"></div>
      
      <Link to="/" className="back-button">
        ← Back to All Signs
      </Link>

      <div className="horoscope-detail">
        <div className="horoscope-header">
          <h1 className="horoscope-title">
            <span className="horoscope-symbol" style={{ color: zodiacSign.color }}>
              {zodiacSign.symbol}
            </span>
            {zodiacSign.name} {activeTab === 'yearly' ? 'Yearly' : 'Daily'} Horoscope
          </h1>
          <p className="zodiac-date">{zodiacSign.dateRange}</p>
        </div>

        <div className="nav-tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`nav-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
              style={{
                borderColor: activeTab === tab.id ? zodiacSign.color : undefined
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="horoscope-content">
          <p className="horoscope-date">
            {activeTab === 'yearly' ? 'Yearly Forecast' : getDateForTab(activeTab)}
          </p>
          <p>
            {horoscopeData[activeTab]}
          </p>
        </div>
      </div>
    </div>
  );
};

export default HoroscopeDetail;
